import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import './assets/base.css'
import DOMPurify from 'dompurify'
import * as Sentry from '@sentry/vue'
import { Constants } from './utils/enums'
import { setupChunkReloadRecovery } from './utils/chunkReloadRecovery'
import { setupNewBuildReload } from './utils/newBuildReload'
import { applyIosInputZoomPrevention } from './utils/viewport'

const app = createApp(App)

app.use(createPinia())

setupChunkReloadRecovery()
setupNewBuildReload(router)

// iOS / iPadOS のみ viewport に maximum-scale=1.0 を付与し、
// font-size < 16px の form フォーカス時の自動ズームを防ぐ
applyIosInputZoomPrevention()

app.use(router)
app.use(ElementPlus)

app.config.globalProperties.$sanitize = DOMPurify.sanitize // usage: v-html="$sanitize(hoge)"

if (Constants['ENV_NAME'] !== 'development') {
  Sentry.init({
    app,
    dsn: Constants['SENTRY_DSN'],
    environment: Constants['ENV_NAME'],
    integrations: [
      Sentry.browserTracingIntegration({ router, routeLabel: 'path' }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 0.2, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    // userInfo は IP アドレス等の user 情報を event に自動付与する設定。
    dataCollection: { userInfo: true },
    enableLogs: true,
  })
}

app.mount('#app')
